import { createActionTypes } from 'utils/action/actionTypes';

export const UPLOAD_NO_LOAD_REPORT = createActionTypes('UPLOAD_NO_LOAD_REPORT');
export const FETCH_NO_LOAD_REPORT = createActionTypes('FETCH_NO_LOAD_REPORT');
export const DOWNLOAD_NO_LOAD_REPORT = createActionTypes('DOWNLOAD_NO_LOAD_REPORT');
